import { useState } from 'react';
import { Form } from 'react-bootstrap';
import Loading from 'src/components/Loading';

import './AsyncSelect.css';

let debounceTimer = null;
const DEBOUNCE_TIME = 300;
const AsyncSelect = ({ id, value, noOptionsMessage, onChange, loadOptions }) => {
  const [search, setSearch] = useState('');
  const [focused, setFocused] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadOptionsDebounced = (search) => {
    setLoading(true);
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    debounceTimer = setTimeout(async () => {
      setOptions(await loadOptions(search));
      setLoading(false);
    }, DEBOUNCE_TIME);
  };

  const chooseOption = (option) => {
    onChange(option);
    setFocused(false);
    setSearch('');
  };

  return (
    <div
      id={id}
      className="position-relative async-select"
      tabIndex={0 /*tabIndex makes the onBlur event fire correctly*/}
      onBlur={(event) => {
        // for some reason, this line fixes the fact that the position:absolute
        // dropdown's event is overridden by this `setFocused` event
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setFocused(false);
        }
      }}
    >
      <div className="d-flex align-items-center">
        <Form.Control
          className="async-select-input"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            loadOptionsDebounced(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (options.length > 0) {
                chooseOption(options[0]);
              }
            }
          }}
          placeholder={value?.label}
          onFocus={() => setFocused(true)}
        ></Form.Control>
        {loading && <Loading size="sm" />}
      </div>
      {focused && (
        <div
          className="position-absolute bg-white p-3 border rounded shadow"
          style={{ top: 42, left: 0, right: 0, maxHeight: 200, overflowY: 'auto' }}
        >
          {options.length < 1 ? (
            <span className="text-muted">{noOptionsMessage(search)}</span>
          ) : (
            options.map((option) => (
              <div key={option.email} className="option p-2" onClick={() => chooseOption(option)}>
                {option.label}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default AsyncSelect;
